import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Terms',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    content: {
      title: 'Treść regulaminu*',
      type: 'string',
      fieldRequired: true
    },
    order: {
      type: 'number',
      fieldRequired: true
    },
    profileType: {
      type: 'string',
      fieldRequired: false
    },
    type: {
      type: 'string',
      fieldRequired: true
    },
    required: {
      type: 'boolean'
    },
    mediaId: {
      title: 'Plik z treścią regulaminu',
      type: 'number',
      fieldRequired: false
    },
    start: {
      title: 'Początek obowiązywania regulaminu*',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    end: {
      title: 'Koniec obowiązywania regulaminu',
      type: 'string',
      format: 'date'
    }
  }
};
